import {
  PermissionTypes,
  UserHasPermissionResponse,
  ListedProduct,
  transformProductListResponse,
} from 'helper/products';
import baseApi, { GenericResponse } from '../base';

export const productsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    userHasPermission: build.query<UserHasPermissionResponse, PermissionTypes>({
      query: (product) => (
        `admin/contratos/current-user-has-permission/?item=${product}`
      ),
      // 4h in seconds, since a product key is supposed to last 6 hours
      keepUnusedDataFor: 60 * 60 * 4,
    }),
    listProducts: build.query<Array<ListedProduct>, void>({
      query: () => 'admin/produtos/get-all',
      transformResponse: transformProductListResponse,
    }),
    // Tela "Solicitar acesso" (NoAccessPage): usuario sem acesso pede acesso a
    // um produto. Sem body — a identidade vem da sessao/JWT (header Authorization
    // do baseApi). `produto` e o identificador da tela (permissionKey). 202.
    solicitarAcesso: build.mutation<GenericResponse<unknown>, { produto: string }>({
      query: ({ produto }) => ({
        url: `produtos/${produto}/solicitar-acesso`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useListProductsQuery,
  useUserHasPermissionQuery,
  useSolicitarAcessoMutation,
} = productsApi;
